import { useState } from 'react';
import { Dayjs } from 'dayjs';

export const useStatusChangeConfirmationModal = () => {
  const [dateOfBirth, setDateOfBirth] = useState<Dayjs | null>(null);

  return {
    dateOfBirth,
    setDateOfBirth,
  };
};
